<template>
  <div class="benevole-wrap pt-20 pb-20">
    <div class="container mx-auto px-4">
      <!-- Titre principal -->
      <h2 class="text-3xl font-bold text-center mb-8 text-gray-800 uppercase">
        Bénévoles
      </h2>

      <!-- Contenu principal -->
      <div class="prose max-w-4xl mx-auto text-justify leading-relaxed text-gray-800">
        <p class="text-lg mb-6">
          Les <strong>Bénévoles de l’EITP</strong> sont les disciples ayant décidé librement
          d’offrir une partie de leur temps à l’école.
        </p>

        <blockquote class="border-l-4 border-yellow-500 bg-yellow-50 rounded-md pl-4 pr-4 py-3 italic text-gray-700 mb-6">
          Offrir sa disponibilité comme bénévole, en divers services
          (<em>secrétariat, bibliothèque, service financier, etc.</em>),
          selon ses temps.
        </blockquote>

        <p class="mt-6 italic text-center text-gray-600 text-lg">
          « Servir est une grâce, et le service dans la joie fait grandir la mission. »
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BeneVoles",
  setup() {
    return {};
  },
});
</script>

<style scoped>
.benevole-wrap {
  background-color: #fdfdfd;
}

.prose p {
  margin-bottom: 1rem;
}


blockquote {
  background-color: #fff9db;
  border-left: 4px solid #facc15; 
  border-radius: 0.5rem;
}
</style>
